import React from "react";
import "./SustainX.css";
import realTime from "../../assets/svg/real-time.png";
import auto from "../../assets/svg/auto.png";
import notification from "../../assets/svg/notification.png";
import report from "../../assets/svg/report .png";

function SustainX() {
  return (
    <div>
      <div className="sustain-x-image">
        <div className="sustain-x-content">
          <div className="sustain-x-text">
            <div className="sustain-x-header">
              SUSTAIN-X <br /> ESG PLATFORM
            </div>
            <div className="sustain-x-sub">
              Norem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos.
            </div>
            <div className="sustain-x-button">
              <a href="/" className="sustain-x-read-more-btn-1">
                เรียนรู้เพิ่มเติม
              </a>
              <a href="/" className="sustain-x-read-more-btn-2">
                เริ่มใช้งาน
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="sustain-x-feature">
        <div className="sustain-x-feature-header">
          <div className="sustain-x-feature-header-left">
            <div className="sustain-x-feature-header-left-text-header">
              SUSTAIN-X
            </div>
            <div className="sustain-x-feature-sub-header">
              ESG Management Platform
            </div>
            <div className="sustain-x-sub">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
              turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus
              nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum
              tellus elit sed risus. Maecenas eget condimentum velit, sit amet
              feugiat lectus. Class aptent taciti sociosqu ad litora torquent
              per conubia nostra, per inceptos himenaeos. Praesent auctor purus
              luctus enim egestas, ac scelerisque ante pulvinar.
            </div>
          </div>
          <div className="sustain-x-feature-header-right">
            <div className="sustain-x-feature-header-right-head">Feature</div>
            <div className="sustain-x-feature-header-right-sub">30+</div>
          </div>
        </div>
        <div className="sustain-x-feature-sub">
            <div className="row-sustain-x-feature-sub">
                <div className="card-row-sustain-x-feature-sub">
                  <img src={realTime} alt="" className="sustain-x-logo-style" />
                  <div className="text-card-row-sustain-x-feature">
                      <div className="text-card-row-sustain-x-feature-head">
                      Real-time Monitoring
                      </div>
                      <div className="text-card-row-sustain-x-feature-sub">
                      Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.
                      </div>
                  </div>
                </div>
                <div className="card-row-sustain-x-feature-sub">
                  <img src={auto} alt="" className="sustain-x-logo-style" />
                  <div className="text-card-row-sustain-x-feature">
                      <div className="text-card-row-sustain-x-feature-head">
                      Auto calculating ESG Score
                      </div>
                      <div className="text-card-row-sustain-x-feature-sub">
                      Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.                      </div>
                  </div>
                </div>
            </div>
            <div className="row-sustain-x-feature-sub">
                <div className="card-row-sustain-x-feature-sub">
                  <img src={notification} alt="" className="sustain-x-logo-style" />
                  <div className="text-card-row-sustain-x-feature">
                      <div className="text-card-row-sustain-x-feature-head">
                      Notification report
                      </div>
                      <div className="text-card-row-sustain-x-feature-sub">
                      Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.
                      </div>
                  </div>
                </div>
                <div className="card-row-sustain-x-feature-sub">
                  <img src={report} alt="" className="sustain-x-logo-style" />
                  <div className="text-card-row-sustain-x-feature">
                      <div className="text-card-row-sustain-x-feature-head">
                      Report a summary of analysis result
                      </div>
                      <div className="text-card-row-sustain-x-feature-sub">
                      Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default SustainX;
